<template>
    <img
        :src="isSearchDemo ? sourceHatchLogo : defaultLogo"
        :alt="isSearchDemo ? 'SourceHatch Demo' : alt"
        :class="{
            'sourcehatch-demo-logo': isSearchDemo,
            'sourcehatch-demo-logo--opaque': isSearchDemo && !transparent,
        }"
    />
</template>

<script>
    import config from '@/services/config'
    import sourceHatchLogo from '@/assets/sourcehatch-demo-logo.png'
    import transparentSourceHatchLogo from '@/assets/sourcehatch-demo-logo-transparent.png'
    import standardLogo from '@/assets/logo-v2.png'
    import formLogo from '@/assets/logo-crop.png'
    import vectorLogo from '@/assets/logo-v2.svg'

    const defaultLogos = { standard: standardLogo, form: formLogo, vector: vectorLogo }

    export default {
        name: 'BrandLogo',
        props: {
            transparent: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: 'standard',
                validator: (value) => Object.hasOwn(defaultLogos, value),
            },
            alt: {
                type: String,
                default: '',
            },
        },
        computed: {
            isSearchDemo() {
                return config.isSearchDemo()
            },
            sourceHatchLogo() {
                return this.transparent ? transparentSourceHatchLogo : sourceHatchLogo
            },
            defaultLogo() {
                return defaultLogos[this.variant]
            },
        },
    }
</script>

<style scoped>
    .sourcehatch-demo-logo {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }

    .sourcehatch-demo-logo--opaque {
        background: #fff;
        border-radius: 4px;
    }
</style>
